import { RouteItem } from '~/types/layoutMenu';

export const isDisabled = (item: RouteItem, permissions: string[]): boolean => {
  if (item.requireAllPermissions) {
    return !item.requireAllPermissions.every((p) => permissions?.includes(p));
  }
  if (item.permission) {
    if (Array.isArray(item.permission)) {
      return !item.permission.some((p) => permissions?.includes(p));
    }
    return !permissions?.includes(item.permission);
  }
  return false;
};

// `path` matches itself and its sub-routes by default (e.g. `/foo` matches `/foo/123`,
// and `/foo/` matches `/foo/123` too). Pass `exact: true` when a sub-route belongs to a
// different menu entry — e.g. `/fxrates` must not match `/fxrates/setup`, which is its own
// entry elsewhere in the menu. `/` never matches sub-routes — every path starts with `/`.
export const isPathMatch = (path: string, pathname: string, exact?: boolean) => {
  if (exact || path === '/') return pathname === path;
  const prefix = path.endsWith('/') ? path.slice(0, -1) : path;
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
};

// Entries in a group's `paths` list are prefixes; prefix one with `=` for an exact match
// (same purpose as RouteItem's `exact` flag, but `paths` is a plain string[]).
export const pathActive = (paths: string[], pathname: string) =>
  paths.some((p) =>
    p.startsWith('=') ? isPathMatch(p.slice(1), pathname, true) : isPathMatch(p, pathname)
  );
